/**
 * React Application Entry Point
 *
 * Mounts the root App component into the DOM.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initEmbeddedMode } from './utils/embedded';
import { installStaleChunkReload } from './utils/staleChunkReload';
import './index.css';

// Inside the Compass App's WebView the shell owns navigation; decide before
// the first render so AppShell never flashes the Sidebar (utils/embedded.ts).
initEmbeddedMode();
// A deploy can retire the chunk names this tab knows; reload once instead of crashing.
installStaleChunkReload();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
